var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenSaveTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_33",
    "data-name": "\\uADF8\\uB8F9 33",
    transform: "translate(-431 -255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_30",
    "data-name": "\\uD0C0\\uC6D0 30",
    transform: "translate(431 255)",
    fill: "rgba(17,17,53,0.25)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_138",
    "data-name": "\\uC0AC\\uAC01\\uD615 138",
    transform: "translate(443 273)",
    fill: "rgba(255,255,255,0.15)",
    stroke: "#30abeb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_15",
    "data-name": "\\uC120 15",
    x2: 46,
    transform: "translate(443.5 281.5)",
    fill: "none",
    stroke: "#30abeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_16",
    "data-name": "\\uC120 16",
    y2: 5.787,
    transform: "translate(452.945 267.713)",
    fill: "none",
    stroke: "#30abeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_17",
    "data-name": "\\uC120 17",
    y2: 5.787,
    transform: "translate(479 267.713)",
    fill: "none",
    stroke: "#30abeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_104",
    "data-name": "\\uD328\\uC2A4 104",
    d: "M2442.945,2602.5l8.7,10.9s13.789-11.43,18.385-14.156",
    transform: "translate(-1990 -2312)",
    fill: "none",
    stroke: "#30abeb",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenSaveTime);
export default __webpack_public_path__ + "static/media/ben_save_time.5762b1154412769ec25defb5eb16dcdc.svg";
export { ForwardRef as ReactComponent };